import React from "react";
import { useLocation, useParams } from "react-router-dom";
import { CandidateView } from "../molecules/CandidateView";
import { CandidateCard } from "../organisms/CandidateCard";

export const CandidateDashboard = () => {
  const location = useLocation();
  const { candidateId: paramCandidateId } = useParams();

  const candidateId = (location.state && location.state.candidateId) || paramCandidateId;
  const applicationId = location.state && location.state.applicationId;
  const jobId = location.state && location.state.jobId;
  const fullName = (location.state && location.state.fullName) || "Candidate";

  if (!candidateId || !applicationId) {
    return (
      <div className="p-4">
        <h2 className="font-bold text-red-500">No candidate selected</h2>
        <p>Please go back and select a candidate from the list.</p>
      </div>
    );
  }

  return (
    <div className="flex flex-col flex-1 w-full p-4">
      <h1 className="text-2xl font-bold">Candidate Dashboard</h1>
      <div className="flex flex-col flex-1 gap-6 mt-4">
        <CandidateView applicationId={applicationId} fullName={fullName} jobId={jobId} />
        <CandidateCard candidateId={candidateId} />
      </div>

      <style>{`
        :where(button, a, input, select, textarea):focus {
          outline: 2px solid #FFCC00;
          box-shadow: 0 0 0 3px rgba(255,204,0,.35);
          border-color: #FFCC00 !important;
        }
      `}</style>
    </div>
  );
};
